import { CONSTANTS } from './constants'
import { addressFilter } from './addressFilter'
import { filterSectorAgencies } from './patrimonyFilter'

export const getFilteredAddresses = (addresses, searchTerm, type, associatedAgencies, selectedItems) => {
  let filtered = addressFilter(addresses, searchTerm)

  if (type === CONSTANTS.AGENCY_TYPES.ASSOCIATED) {
    const agenciesToShow = [...associatedAgencies, ...selectedItems]
    return filtered.map((patrimony) => ({
      ...patrimony,
      sectors: patrimony.sectors.map((sector) => ({
        ...sector,
        agencies: filterSectorAgencies(sector, agenciesToShow, true),
      })),
    }))
  }

  return filtered
}

export const calculateTotalAddresses = (filteredAddresses, type, associatedAgencies, selectedItems) => {
  return filteredAddresses.reduce(
    (total, patrimony) =>
      total +
      patrimony.sectors.reduce(
        (sectorTotal, sector) =>
          sectorTotal +
          sector.agencies.filter((agency) => {
            if (type === CONSTANTS.AGENCY_TYPES.ASSOCIATED) {
              return associatedAgencies.includes(agency.id) || selectedItems.includes(agency.id)
            }
            if (type === CONSTANTS.AGENCY_TYPES.AVAILABLE) {
              return !associatedAgencies.includes(agency.id)
            }
            return true
          }).length,
        0,
      ),
    0,
  )
}

export const extractAgencyIds = (filteredAddresses, type, associatedAgencies, selectedItems) => {
  const agencyIds = []
  filteredAddresses.forEach((patrimony) => {
    patrimony.sectors.forEach((sector) => {
      sector.agencies.forEach((agency) => {
        if (type === CONSTANTS.AGENCY_TYPES.AVAILABLE && !associatedAgencies.includes(agency.id)) {
          agencyIds.push(agency.id)
        } else if (type === CONSTANTS.AGENCY_TYPES.ASSOCIATED && (associatedAgencies.includes(agency.id) || selectedItems.includes(agency.id))) {
          agencyIds.push(agency.id)
        }
      })
    })
  })
  return agencyIds
}
export const getExpandedItemIds = (addresses) => {
  return addresses.reduce((acc, patrimony) => {
    acc.push(patrimony.id)

    patrimony.sectors.forEach((sector) => {
      if (sector.agencies.length > 0) {
        acc.push(sector.id)
      }
    })

    return acc
  }, [])
}
